import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import brandTheme from "../../../brandTheme/Theme";
import CustomeTextField from "../CustomeTextField";
import { toCamelCase } from "utils/Utils";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import RefreshIcon from "@material-ui/icons/Refresh";
const useStyles = makeStyles(() => ({
  mainContainer: {
    marginBottom: "17px",
    borderBottom: `1px solid ${brandTheme.mainColor}`,
    paddingBottom: "1.5%",
    alignItems: "center",
    display: "flex",
    '@media only screen and (max-width: 600px)': {
        display:'block',
    },
  },
  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform:"capitalize",
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  label: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    fontFamily: brandTheme.font.poppins,
    marginTop:'15px',
    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
      marginBottom: "15px",
      "&:first-child": {
        marginTop: "15px",
      },
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "right",
    fontFamily: brandTheme.font.poppins,
    paddingRight: "5%",
    gap: "15px",
    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
    },
  },
  button2: {
    minWidth: "140px",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  searchButton:{
    marginTop:"3%"
  },
  refreshButton: {
  minWidth: "170px",
  backgroundColor: "#fff",
  color: "#297AE5",
  border: `1px solid #297AE5`,
  borderRadius: "10px",
  fontWeight: 600,
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
},
}));

const SubHeader = ({
  label,
  button1,
  button2,
  disabled1,
  disabled2,
  button1click,
  button2click,
  searchLabel,
  search,
  onSearchChange,
  select1,
  select1Label,
  setSelect1,
  select1Data,
  select1Type,
  select2,
  select2Label,
  setSelect2,
  select2Data,
  select2Type,
  refreshButton,
  refreshDisabled,
  refreshButtonClick,
  error,
  setError
}) => {
  const classes = useStyles();
  return (
      <Grid container>
    <Grid item xs={12} sm={12} md={12} className={classes.mainContainer}>
        <Grid item xs={12} sm={search ? 4 : 6} md={search ? 4 : 6} className={classes.label}>
          {label && toCamelCase(label)}
        </Grid>
        {search && (<Grid item xs={12} sm={onSearchChange ? 4 : 2} md={onSearchChange ? 4 : 2} className={classes.label}>
            <CustomeTextField
              label={searchLabel}
              onchange={onSearchChange}
              search={search}
            />
        </Grid>
         )}
        {select1Label && (<Grid item xs={12} sm={select2Label ? 3 : 4} md={select2Label ? 3 : 4} className={classes.label}>
            <CustomSelectNew
               label={select1Label}
               value={select1}
               setState={setSelect1}
               data={select1Data}
               type={select1Type}
               error={error}
               setError={setError}
             />
        </Grid>
         )}
        {select2Label && (<Grid item xs={12} sm={3} md={3} className={classes.label}>
             <CustomSelectNew
               label={select2Label}
               value={select2}
               setState={setSelect2}
               data={select2Data}
               type={select2Type}
             />
        </Grid>
         )}
        <Grid item xs={12} sm={onSearchChange ? 4 : 6} md={onSearchChange ? 4 : 6} className={classes.buttonContainer}>
        {refreshButton && (
          <Button
            className={
              search
                ? `${classes.searchButton} ${classes.refreshButton}`
                : classes.refreshButton
            }
            disabled={refreshDisabled}
            onClick={refreshButtonClick}
            startIcon={<RefreshIcon />}
          >
            Refresh Rates
          </Button>
        )}
          {button1 && (
            <Button
              className={search ? `${classes.searchButton} ${classes.button}` : classes.button}
              disabled={disabled1}
              onClick={() => button1click()}
              id="button"
            >
              {button1}
            </Button>
          )}
          {button2 && (
            <Button
              className={search ? `${classes.searchButton} ${classes.button2} ${classes.button}` : `${classes.button2} ${classes.button}`}
              disabled={disabled2}
              onClick={() => button2click()}
              id="button"
            >
              {button2}
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SubHeader;